import Service from "../DepartmentService";

function GetByDepartmentId() {
    return Service.get('Course');
}


const CourseService = {
    GetByDepartmentId
};

export default CourseService;
